import classNames from 'classnames';
import { Fragment, PropsWithChildren } from 'react';

import { marginsClassNames } from '../utils/style';

interface SectionTitleProps {
  className?: string;
  title: string;
}

const SectionTitle = ({ className, title }: SectionTitleProps) => (
  <span className={className}>
    {title.split(' ').map((w, i, { length }) => (
      <Fragment key={`${w}-${i}`}>
        <span className="text-accent">{w[0]}</span>
        <span>{w.slice(1)}</span>
        {i < length - 1 && ' '}
      </Fragment>
    ))}
  </span>
);

const highlightClassNames = 'border-b-8 border-accent';

interface SectionProps {
  odd?: boolean;
  title?: string;
  titleSmall?: string;
}

const Section = ({ children, odd, title, titleSmall }: SectionProps & PropsWithChildren) => {
  return (
    <section className="not-last:mb-15 print:not-last:mb-10 not-print:max-desktop:not-last:mb-8">
      {title && (
        <div className="flex mb-10 not-print:max-desktop:mb-5">
          <div className={classNames('grow basis-0', odd && highlightClassNames)} />
          <h2 className={classNames(highlightClassNames, 'shrink-0 inline-block pb-1 font-title text-[2.6rem] lowercase')}>
            <SectionTitle className={titleSmall ? 'not-print:max-desktop:hidden' : ''} title={title} />
            {titleSmall && <SectionTitle className="desktop:hidden print:hidden" title={titleSmall} />}
          </h2>
          <div className={classNames('grow basis-0', !odd && highlightClassNames)} />
        </div>
      )}
      <div className={marginsClassNames}>{children}</div>
    </section>
  );
};

export default Section;
